import { actions } from 'src/actions/pos.actions'
import { successState } from 'src/actions/global.actions'

const initialState: POSState = {
  configuration: {},
}

const POSReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case successState(actions.GET_POS_METHOD_PAYMENT_CONFIGURATION):
      return { ...state, configuration: payload }
    default:
      return state
  }
}

export default POSReducer
